module.exports = __webpack_public_path__ + "img/组 102.fd02ce8d.png";